"use client";

import { c as _c } from "react/compiler-runtime";
import { NextGenCollection } from "@/entities/INextgen";
import { NextgenCollectionView } from "@/enums";
import { formatAddress } from "@/helpers/Helpers";
import Link from "next/link";
import { Col, Container, Row, Table } from "react-bootstrap";
import { Tooltip } from "react-tooltip";
import { goerli, sepolia } from "viem/chains";
import { NEXTGEN_CHAIN_ID, NEXTGEN_CORE } from "@/components/nextGen/nextgen_contracts";
import { DistributionLink } from "../NextGen";
import styles from "../NextGen.module.scss";
import NextGenCollectionProvenance from "./NextGenCollectionProvenance";
import NextGenTraitSets from "./NextGenTraitSets";
interface CollectionProps {
  collection: NextGenCollection;
}
interface Props extends CollectionProps {
  view: NextgenCollectionView;
}
function NextGenCollectionDetailsOverview(props) {
  const $ = _c(38);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = function getEtherscanLink() {
      let chainName = "";
      if (NEXTGEN_CHAIN_ID === sepolia.id) {
        chainName = "sepolia.";
      }
      if (NEXTGEN_CHAIN_ID === goerli.id) {
        chainName = "goerli.";
      }
      return `https://${chainName}etherscan.io/address/${NEXTGEN_CORE[NEXTGEN_CHAIN_ID]}`;
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const getEtherscanLink = t0;
  let t1;
  if ($[1] !== props.collection.artist_signature) {
    t1 = props.collection.artist_signature && <><Row><Col className="font-color-h">Artist Signature</Col></Row><Row className="pb-2"><Col xs={12} className="pt-2"><div className={styles.artistSignature} dangerouslySetInnerHTML={{
            __html: props.collection.artist_signature
          }} /></Col></Row></>;
    $[1] = props.collection.artist_signature;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className="font-color-h">Allowlist</span>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props.collection) {
    t3 = <Col xs={12} className="pt-2 pb-2 d-flex flex-column">{t2}<DistributionLink collection={props.collection} /></Col>;
    $[4] = props.collection;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="font-color-h">License</span>;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== props.collection.licence) {
    t5 = <span className="d-flex flex-column">{t4}<span>{props.collection.licence}</span></span>;
    $[7] = props.collection.licence;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <span className="font-color-h">Library</span>;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const t7 = props.collection.library ? props.collection.library : "-";
  let t8;
  if ($[10] !== t7) {
    t8 = <span className="d-flex flex-column">{t6}<span>{t7}</span></span>;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t5 || $[13] !== t8) {
    t9 = <Col xs={12} className="pt-2 pb-2 d-flex gap-5">{t5}{t8}</Col>;
    $[12] = t5;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <span className="font-color-h">Contract</span>;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  const t11 = getEtherscanLink();
  const t12 = `contract-tooltip-${props.collection.id}`;
  let t13;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = formatAddress(NEXTGEN_CORE[NEXTGEN_CHAIN_ID]);
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] !== t12) {
    t14 = <Link className="font-color text-decoration-none" href={t11} target="_blank" rel="noopener noreferrer" data-tooltip-id={t12}>{t13}</Link>;
    $[17] = t12;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  const t15 = `contract-tooltip-${props.collection.id}`;
  let t16;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = {
      backgroundColor: "#1F2937",
      color: "white",
      padding: "4px 8px"
    };
    $[19] = t16;
  } else {
    t16 = $[19];
  }
  let t17;
  if ($[20] !== t15) {
    t17 = <Tooltip id={t15} place="right" delayShow={500} style={t16}>{NEXTGEN_CORE[NEXTGEN_CHAIN_ID]}</Tooltip>;
    $[20] = t15;
    $[21] = t17;
  } else {
    t17 = $[21];
  }
  let t18;
  if ($[22] !== t14 || $[23] !== t17) {
    t18 = <Col xs={12} className="pt-2 pb-2 d-flex flex-column">{t10}<span>{t14}{t17}</span></Col>;
    $[22] = t14;
    $[23] = t17;
    $[24] = t18;
  } else {
    t18 = $[24];
  }
  let t19;
  if ($[25] !== t18 || $[26] !== t3 || $[27] !== t9) {
    t19 = <Row>{t3}{t9}{t18}</Row>;
    $[25] = t18;
    $[26] = t3;
    $[27] = t9;
    $[28] = t19;
  } else {
    t19 = $[28];
  }
  let t20;
  if ($[29] !== t1 || $[30] !== t19) {
    t20 = <Col sm={12} md={4} className="pt-2 pb-2">{t1}{t19}</Col>;
    $[29] = t1;
    $[30] = t19;
    $[31] = t20;
  } else {
    t20 = $[31];
  }
  let t21;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <span className="font-color-h">Collection Overview</span>;
    $[32] = t21;
  } else {
    t21 = $[32];
  }
  let t22;
  if ($[33] !== props.collection.description) {
    t22 = <Col sm={12} md={8} className="pt-2 pb-2 d-flex flex-column">{t21}<span>{props.collection.description}</span></Col>;
    $[33] = props.collection.description;
    $[34] = t22;
  } else {
    t22 = $[34];
  }
  let t23;
  if ($[35] !== t20 || $[36] !== t22) {
    t23 = <Container className="no-padding"><Row><Col><Container className="no-padding"><Row>{t20}{t22}</Row></Container></Col></Row></Container>;
    $[35] = t20;
    $[36] = t22;
    $[37] = t23;
  } else {
    t23 = $[37];
  }
  return t23;
}
function NextGenCollectionDetailsAbout(props) {
  const $ = _c(10);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Row className="pb-3"><Col><h4>About Pebbles</h4></Col></Row>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Row className="pb-3"><Col><p>Pebbles aims to explore the order that can emerge from a small set of organically inspired elements of points, lines, textures, and light.</p></Col></Row>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Row className="pb-3"><Col><h4>History of Technical Innovation</h4></Col></Row>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Row className="pb-3"><Col><p>ZeBlocks prides itself on technical innovation in its generative mints and on-chain work. Most ZeBlocks projects, including Pebbles, are 100% on-chain, and do not use any external libraries.</p><p>Pebbles follows in the tradition of prior ZeBlocks projects:</p><ul><li>{"Unigrids: SVG-based generative art & music project"}</li><li>Beatboxes: First fully immersive VR audiovisual generative art</li><li>Sensthesia: Audio-sensitive generative art NFTs</li></ul></Col></Row>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Row className="pb-3"><Col><h4>Pebbles: Matched To The Human Eye</h4></Col></Row>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Row className="pb-3"><Col><p>Pebble is one of the highest-resolution generative collections ever released</p><ul><li>The Challenge:</li><ul><li>With the exception of SVG-based collections (that typically have simpler structures), most generative collections do not, in practice, have unlimited scalability resolution-wise</li><li>An output can be scaled up and rendered to a higher resolution but if the underlying data point density does not exist in the algorithm, render quality will typically start to suffer above 4K</li></ul></ul><ul><li>The Goal</li><ul><li>Pebbles aims to provide sufficient resolution to match or exceed the acuity of the human eye even in a world of wall-sized TVs or AR devices</li><li>Under typical large-screen TV viewing distances, 4K or 8K is more than sufficient to exceed the acuity of the human eye</li><li>If wall-size TVs become common in the future, the limit of human vision to discern differences in resolutions, under normal conditions, will move up to somewhere between 8K and 16K</li><li>Pebbles is designed to have no loss of resolution at all up to 12.5K and continue to provide extraordinary detail at 16K and beyond</li><li>In practice, and under the large majority of future display conditions, every Pebble has more resolution than the human eye can discern</li></ul></ul><ul><li>The Approach</li><ul><li>The Pebble algorithm address this issue in two ways:</li><ul><li>Very dense number of data points</li><li>Matches the data points to the exact pixels available at each render, regardless of resolution</li></ul><li>This makes it computationally expensive to render. Pebbles does not use p5.js or other processing libraries to improve rendering performance, particularly at large sizes.</li></ul></ul></Col></Row>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Row className="pb-3"><Col><h4>NextGen x Pebbles</h4></Col></Row>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Row className="pb-3"><Col><p>NextGen will take the following approach to support Pebbles’s extraordinary resolution:</p><ul><li>On mint day, NextGen will initially render Pebble mints in 1K (it will still take several minutes per mint given the complexity). This will allow a first look at the outputs.</li><li>Post mint, the base image will be re-rendered in 2K for online viewing.</li><li>NextGen will also provide 4K, 8K and 16K renders for download and printing. We can’t wait for people to dig into these super high quality renders.</li><li>Though NextGen can serve collection renders 100% on-chain, the switch to on-chain rendering for the Pebbles Collection will be delayed until GPU improvements allow for reasonable real-time rendering times. This does not impact other NextGen collections which can go fully on-chain independently.</li></ul></Col></Row>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Row className="pb-3"><Col><h4>Key Collection Parameters</h4></Col></Row>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Container className="no-padding pt-4">{t0}{t1}{t2}{t3}{t4}{t5}{t6}{t7}{t8}<Row className="pb-3"><Col><Table><tbody><tr><td>Collection Size:</td><td>1,000 (or fewer, if fewer are minted in 24 hours)</td></tr><tr><td>Orientation:</td><td>Vertical</td></tr><tr><td>Aspect Ratio:</td><td>1:1.294</td></tr><tr><td>Script:</td><td>Javascript</td></tr><tr><td>Script Size:</td><td>17Kb</td></tr><tr><td>External libraries used:</td><td>None</td></tr><tr><td>License:</td><td>Creative Commons 0 (CC0)</td></tr><tr><td>Prints:</td><td>An official ZeBlocks approved printing process will be available in a few weeks</td></tr></tbody></Table></Col></Row></Container>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  return t9;
}
export default function NextGenCollectionDetails(props) {
  const $ = _c(8);
  if (props.view === NextgenCollectionView.PROVENANCE) {
    let t0;
    if ($[0] !== props.collection) {
      t0 = <NextGenCollectionProvenance collection={props.collection} />;
      $[0] = props.collection;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    return t0;
  } else {
    if (props.view === NextgenCollectionView.OVERVIEW) {
      let t0;
      if ($[2] !== props.collection) {
        t0 = <NextGenCollectionDetailsOverview collection={props.collection} />;
        $[2] = props.collection;
        $[3] = t0;
      } else {
        t0 = $[3];
      }
      return t0;
    } else {
      if (props.view === NextgenCollectionView.TOP_TRAIT_SETS) {
        let t0;
        if ($[4] !== props.collection) {
          t0 = <NextGenTraitSets preview={true} collection={props.collection} />;
          $[4] = props.collection;
          $[5] = t0;
        } else {
          t0 = $[5];
        }
        return t0;
      } else {
        let t0;
        if ($[6] !== props.collection) {
          t0 = <NextGenCollectionDetailsAbout collection={props.collection} />;
          $[6] = props.collection;
          $[7] = t0;
        } else {
          t0 = $[7];
        }
        return t0;
      }
    }
  }
}